import { Button, Stack } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import { useGetLink } from "../hooks/useGetLink";
import PositionTypeToggle from "./PositionTypeToggle";
import ThemeModeToggle from "./ThemeModeToggle";

// ----------------------------------------------------------------------

export const UrlFooter = () => {
	const { translate } = useLocales();
	const { link } = useGetLink();

	return (
		<Stack
			flexDirection={{ xs: "column", sm: "row" }}
			alignItems={"center"}
			justifyContent={"space-between"}
			sx={{ mt: 2 }}
		>
			<PositionTypeToggle />
			<Stack flexDirection={"row"} alignItems={"center"} mt={2}>
				<ThemeModeToggle />
				<Button variant='contained' onClick={() => window.open(link, "_blank")} sx={{ ml: 2 }}>
					{translate("url_panel.open_link")}
				</Button>
			</Stack>
		</Stack>
	);
};

export default UrlFooter;
